// Public origin that serves Supabase Storage objects and image transforms
// (`/storage/v1/object/...` and `/storage/v1/render/image/...`). This is the
// single source of truth for the storage host — used by asset-url.ts (object
// URLs) and supabase-image.tsx (render/transform URLs).
//
// Resolution order:
//   1. NEXT_PUBLIC_SUPABASE_MEDIA_URL — the Supabase custom domain
//      (https://media.hearingtracker.com), preferred everywhere.
//   2. NEXT_PUBLIC_SUPABASE_PROJECT_ID — the project's *.supabase.co host.
//   3. The prod project host as a last-ditch default.
//
// It intentionally never returns the local stack (127.0.0.1): public pages must
// not serialize local storage URLs, and the render/transform endpoint doesn't
// work locally anyway — so even in local dev, media resolves to the prod host.

const DEFAULT_PROJECT_HOST = 'https://umxyjozklelnvrkwbycp.supabase.co'

export const mediaOrigin = (): string => {
  const media = process.env.NEXT_PUBLIC_SUPABASE_MEDIA_URL
  if (media) {
    return media.replace(/\/+$/, '')
  }
  const projectId = process.env.NEXT_PUBLIC_SUPABASE_PROJECT_ID
  if (projectId) {
    return `https://${projectId}.supabase.co`
  }
  return DEFAULT_PROJECT_HOST
}
